import React, { useEffect, useState } from "react";
import { TagsShow, ChipsTagsView, CoreInputBox } from "./index";

function LanguageView(props) {
  const { filterData, clearFiltersData, setFilterData, api } = props;
  const [activeData, setActiveData] = useState([]);

  useEffect(() => {
    setActiveData("");
  }, [clearFiltersData]);

  useEffect(() => {
    let stringActiveData = activeData?.toString();
    let obj = { language: stringActiveData };
    setFilterData(obj);
  }, [activeData]);

  useEffect(() => {
    const tempActiveData = filterData?.language?.split(",");
    setActiveData(tempActiveData || []);
  }, [filterData]);

  const languages = [
    { title: "Hindi", id: "hindi" },
    { title: "English", id: "english" },
    { title: "Marathi", id: "marathi" },
    { title: "Telugu", id: "telugu" },
  ];

  const renderHeading = () => {
    return <div className="filterHeadings mt-3">Languages</div>;
  };

  const renderChips = () => {
    return (
      <div>
        <div className="mt-3" />
        <ChipsTagsView setActiveTags={setActiveData} activeTags={activeData} data={languages} />
      </div>
    );
  };

  return (
    <div>
      {renderHeading()}
      {renderChips()}
    </div>
  );
}

export default LanguageView;
